import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProofBar } from './components/ProofBar';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen w-full flex flex-col" data-id="element-0" data-mp="28ufpyg1ohml6">
      <UrgencyBar data-id="element-1" data-mp="28suu8n3mnxlq" />
      <HeroSection data-id="element-2" data-mp="28sbcb6dz997p" />
      <ProofBar data-id="element-3" data-mp="23vchelmhoy8g" />
      <PainSection data-id="element-4" data-mp="23vunsb2v8su3" />
      <MechanismSection data-id="element-5" data-mp="23u9v6r043jyv" />
      <ProductSection data-id="element-6" data-mp="23v2s7099qv3t" />
      <BenefitsSection data-id="element-7" data-mp="23ti67z10skhk" />
      <ForWhomSection data-id="element-8" data-mp="3ikh829m9asyz" />
      <OfferSection data-id="element-9" data-mp="3iiwaeb4natww" />
      <FaqSection data-id="element-10" data-mp="3ijpbavgxap74" />
      <FinalCta data-id="element-11" data-mp="3ii4sg33z0up3" />
      <Footer data-id="element-12" data-mp="3mlawr57iwbsx" />
      <RecentPurchaseToast data-id="element-13" data-mp="3ml17xky7saot" />
    </div>;
}